import { defaultParseSearch, type SearchParser } from '@tanstack/react-router';

/**
 * Search keys whose value is a bigint id: `runId` on lodge from documents (`?runId=6`). The default
 * parser JSON-parses every value, so an id past 2^53 reaches the route's schema already rounded
 * (`?runId=9007199254740993` would open run …992). Plain digits under these keys are read straight
 * to a bigint, which the default serialiser writes back as the same digits. Anything else, such as
 * an old JSON-quoted link (`?runId=%226%22`), parses as before for the route's schema to coerce.
 */
const BIGINT_SEARCH_KEYS = ['runId'] as const;

/** Up to 19 digits: longer is past the int8 range, and the route's schema refuses it either way. */
const BIGINT_DIGITS = /^\d{1,19}$/;

/** The router's search parser: the default, except for the bigint id keys above. */
export const parseSearch: SearchParser = (searchStr) => {
    const search: Record<string, unknown> = defaultParseSearch(searchStr);
    const params = new URLSearchParams(searchStr);
    for (const key of BIGINT_SEARCH_KEYS) {
        const values = params.getAll(key);
        const [digits] = values;
        if (values.length === 1 && digits !== undefined && BIGINT_DIGITS.test(digits)) {
            search[key] = BigInt(digits);
        }
    }
    return search;
};
